import dateFormat, { masks } from "dateformat";

const getFormattedDateRU = (numberDate) => {
    const dateFormatRU = dateFormat;
    dateFormatRU.i18n = {
        dayNames: [],
        monthNames: [
            'янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сент', 'окт', 'ноя', 'дек',
            'Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сент', 'Окт', 'Ноя', 'Дек',
            // 'января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
        ],
        timeNames: []
    };

    masks.fullDateFormat = 'd mmmm yyyy';
    masks.dayMonthFormat = 'd mmmm';

    const stringDate = new Date(parseInt(numberDate, 10));
    const currentDate = Date.now();
    const currentStringDate = new Date(parseInt(currentDate, 10));

    const fullDateRU = dateFormatRU(stringDate, "fullDateFormat");
    let dayMonthRU = dateFormatRU(stringDate, "dayMonthFormat");

    const conversionCoefficient = 1000 * 60 * 60 * 24;
    const isToday = stringDate.setHours(0, 0, 0, 0) === currentStringDate.setHours(0, 0, 0, 0);
    const isYesterday = (currentStringDate.setHours(0, 0, 0, 0) - stringDate.setHours(0, 0, 0, 0)) / conversionCoefficient === 1;


    if (isToday) {
        dayMonthRU = 'Сейчас';
    } else if (isYesterday) {
        dayMonthRU = 'Вчера';
    }

    return { fullDateRU, dayMonthRU };
};

export default getFormattedDateRU;
